import { ChunkDataProvider } from '@common/api';
import { FastMovementSystem } from '@common/systems/FastMovementSystem';

import { ClientServiceContainer } from '../services/ClientServiceContainer';

/**
 * Client-side implementation of FastMovementSystem.
 * Provides access to client chunk data.
 */
export class ClientFastMovementSystem extends FastMovementSystem {
  private clientServices: ClientServiceContainer;

  constructor(clientServices: ClientServiceContainer) {
    super(clientServices.common);
    this.clientServices = clientServices;
  }

  protected getChunkDataProvider(): ChunkDataProvider | undefined {
    return this.clientServices.chunkData;
  }
}
